import React from 'react';
import { Query } from 'react-apollo';
import { styled } from 'linaria/react';
import { RowProducts } from '../StartPage/ProductRow/RowProducts';
import BlogHeader from './BlogHeader';
import Head from '@jetshop/core/components/Head';
import blogArticleQuery from './BlogArticleQuery.gql';
import blogArticleDetailedQuery from './BlogArticleDetailedQuery.gql';
import { ContentPadding } from '../Layout/Content/Content';
import { PagePadding } from '../Layout/MaxWidth';
import BlogArticleLoadingState from './BlogArticleLoadingState';
import { theme } from '../Theming/Theming';
import GetStartPage from '../StartPage/GetStartPage';
import BlogItemList from './BlogItemList';
import t from '@jetshop/intl';
import { ProductListHeader } from '../ProductPage/StyledComponents';
import { useLocation } from 'react-router';
import { useBlog } from './hook/useBlog';

export const BlogArticleMaxWidth = styled('div')`
  max-width: 800px;
  margin: 0 auto;
`;

const BlogArticleWrapper = styled('div')`
  margin-top: 2.5rem;
  ${ContentPadding}
  .blog-article-main-area {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .blog-article-content {
    h2,
    h3,
    h4,
    h5 {
      margin: 1.5em 0 1em;
    }
    p {
      line-height: 1.5em;
      margin-bottom: 1rem;
    }
    img {
      margin: 1.5rem 0;
    }
  }
  .blog-article-products {
    ${theme.below.lg} {
      margin-top: 2rem;
    }
  }
  &[data-detailedview='true'] {
    max-width: none;
    width: 100%;
    .article-inner {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      ${theme.above.lg} {
        flex-direction: row;
        .blog-header-wrapper {
          width: 35%;
        }
        .blog-article-products {
          width: 65%;
          padding: 0 3rem;
        }
      }
    }
  }
`;

const StyledProductListHeader = styled(ProductListHeader)`
  margin-top: 4rem;
`;

const BlogArticle = ({ result, configObject, detailedProduct }) => {
  const { data } = result;
  const category = (data && data.route && data.route.object) || null;

  const { articles, menuCategories } = useBlog({
    ...configObject,
    parentId: category && category.parentId,
    excludeId: category && category.id
  });

  if (!data || !category) {
    return <BlogArticleLoadingState />;
  }

  const { route } = data;
  const breadcrumbProps = {
    breadcrumbs: route?.breadcrumbs,
    parents: route?.parents
  };

  const parentCategory = menuCategories.filter(cat => {
    return cat.id === category.parentId;
  });

  const startPageId = false; //parseInt(category.mainHeader, 10);

  return (
    <>
      {category.head && <Head data={category} />}
      <BlogHeader
        category={category}
        parentCategory={parentCategory && parentCategory[0]}
        breadcrumbProps={breadcrumbProps}
      />
      <PagePadding style={{ marginBottom: '5rem' }}>
        {startPageId > 0 && <GetStartPage startPageId={startPageId} />}
        <BlogArticleMaxWidth>
          <BlogArticleWrapper
            data-hasproducts={
              category.products && category.products.result.length > 0
                ? true
                : false
            }
            data-detailedview={detailedProduct ? true : false}
          >
            <div className="article-inner">
              <div className="content-products">
                {category.content && (
                  <div
                    className="blog-article-content content-area"
                    dangerouslySetInnerHTML={{ __html: category.content }}
                  />
                )}
              </div>
            </div>
          </BlogArticleWrapper>
        </BlogArticleMaxWidth>
        {category.products && category.products.result && (
          <div className="blog-article-products">
            <RowProducts category={category} slider={true} />
          </div>
        )}
        {articles && articles.length > 0 && (
          <>
            <StyledProductListHeader>
              {t('You will also like this')}
            </StyledProductListHeader>
            <BlogItemList categories={articles} blogPage={false} />
          </>
        )}
      </PagePadding>
    </>
  );
};

const BlogArticleComp = ({ configObject, detailedProduct = false }) => {
  const location = useLocation();
  const query = detailedProduct ? blogArticleDetailedQuery : blogArticleQuery;
  return (
    <Query query={query} variables={{ path: location.pathname }}>
      {result => (
        <BlogArticle
          configObject={configObject}
          result={result}
          detailedProduct={detailedProduct}
        />
      )}
    </Query>
  );
};

export default BlogArticleComp;
